import { Link, useLocation } from "react-router-dom";
import styles from "./style.module.scss";
import Logo from "src/assets/logo.png";
import { useState, useRef, Dispatch, SetStateAction } from "react";
import { CSSTransition } from "react-transition-group";
import { createFadingAnime } from "src/styles/transition";
import clsx from "clsx";

// SVGを直接定義
const CloseIcon = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em">
    <path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9c-4.4 5.2-.7 13.1 6.1 13.1h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" />
  </svg>
);

export const Header = () => {
  const location = useLocation();
  const [isShowMenu, setIsShowMenu] = useState(false);

  return (
    <header
      className={clsx(
        styles.container,
        location.pathname === "/" && styles.top
      )}
    >
      <div className={styles.logoBox}>
        <Link to="/">
          <img src={Logo} alt="Logo" />
          <h1>ISHINOMAKI MARIN VILLAGE</h1>
        </Link>
      </div>

      <nav>
        <ul>
          <li>
            <Link to="/">HOME</Link>
          </li>
          <li className={styles.division}>
            <p>|</p>
          </li>
          <li>
            <Link to="/activity">体験一覧</Link>
          </li>
          <li className={styles.division}>
            <p>|</p>
          </li>
          <li>
            <Link to="/access">アクセス</Link>
          </li>
          <li className={styles.division}>
            <p>|</p>
          </li>
          <li>
            <Link to="/reservation">ご予約</Link>
          </li>
          <li className={styles.division}>
            <p>|</p>
          </li>
          <li className={styles.contact}>
            <a href="https://forms.gle/dzrBZ2RM3toyT3XD7" target="_blank">
              お問い合わせ
            </a>
          </li>
        </ul>
      </nav>

      <HumbugerMenu
        pathName={location.pathname}
        setIsShowMenu={setIsShowMenu}
      />

      <OverlayMenu isShow={isShowMenu} setIsShowMenu={setIsShowMenu} />
    </header>
  );
};

const HumbugerMenu = ({
  pathName,
  setIsShowMenu,
}: {
  pathName: string;
  setIsShowMenu: Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <div
      className={clsx(styles.humbugerMenu, pathName === "/" && styles.top)}
      onClick={() => setIsShowMenu(true)}
    >
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

const OverlayMenu = ({
  isShow,
  setIsShowMenu,
}: {
  isShow: boolean;
  setIsShowMenu: Dispatch<SetStateAction<boolean>>;
}) => {
  const fade = createFadingAnime(0.25);
  const nodeRef = useRef(null);

  return (
    <CSSTransition in={isShow} timeout={5000} unmountOnExit nodeRef={nodeRef}>
      {(state) => (
        <div className={styles.overlayMenu} style={fade[state]}>
          <div className={styles.closeIconBox}>
            <div className={styles.icon} onClick={() => setIsShowMenu(false)}>
              <CloseIcon />
            </div>
          </div>
          <ul>
            <li>
              <Link to="/" onClick={() => setIsShowMenu(false)}>
                HOME
              </Link>
            </li>
            <li>
              <Link to="/reservation" onClick={() => setIsShowMenu(false)}>
                ご予約
              </Link>
            </li>
            <li>
              <Link
                to="/facility-overview"
                onClick={() => setIsShowMenu(false)}
              >
                基本情報
              </Link>
            </li>
            <li>
              <Link to="/activity" onClick={() => setIsShowMenu(false)}>
                体験一覧
              </Link>
            </li>
            <li>
              <Link to="/access" onClick={() => setIsShowMenu(false)}>
                アクセス
              </Link>
            </li>
            <li>
              <Link to="/faq" onClick={() => setIsShowMenu(false)}>
                FAQ
              </Link>
            </li>

            <li>
              <Link
                to="/accomodation-contract"
                onClick={() => setIsShowMenu(false)}
              >
                宿泊約款
              </Link>
            </li>
            <li>
              <Link to="/personal-policy" onClick={() => setIsShowMenu(false)}>
                個人情報保護方針
              </Link>
            </li>
            <li>
              <a
                href="https://forms.gle/dzrBZ2RM3toyT3XD7"
                target="_blank"
              >
                お問い合わせ
              </a>
            </li>
          </ul>
        </div>
      )}
    </CSSTransition>
  );
};
